import React from 'react';
import Contact from '../contact';

const ContactPage = () => <Contact />;

export default ContactPage;
